
import { defineComponent, onMounted, onUnmounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import CardCreateModal from "../components/cards/CardCreateModal.vue";
import UserMenu from "@/layout/header/partials/UserMenu.vue";
import Logo from "@/components/Logo.vue";
import SidebarDefault from "@/components/sidebar/Sidebar-default.vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "dashboard",
  components: {
    CardCreateModal,
    UserMenu,
    Logo,
    SidebarDefault,
  },
  setup() {
    const store = useStore();
    onMounted(() => {
      setCurrentPageTitle("Home");
      store.dispatch(Actions.GET_LOGS, 8);

      document.body.classList.add("home");
    });

    onUnmounted(() => {
      document.body.classList.remove("home");
    });
  },
});
